<template>
  <div>
    <PremiumBblEditor 
      v-model="content"
      placeholder="Start writing..."
    />
  </div>
</template>

<script>
export default {
  data() {
    return { 
      content: '' // Start with empty content
    }
  }
}
</script>
